module.exports = __webpack_public_path__ + "img/logo.3c476260.png";